var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"homemap",style:({ height: _vm.height + 'px'}),attrs:{"id":"homemap"}}),(_vm.$parent.isApiLoading)?_c('div',{staticClass:"api-loading-indicator"},[_c('i',{staticClass:"fas fa-sync-alt fa-spin"}),_c('span',{staticClass:"ml-2"},[_vm._v("Updating...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }